export default "__VITE_ASSET__BLTIAusK__"